import { createStore } from '@updater-core/lib/store';
import { ENVIRONMENT } from '@updater-core/lib/environment';
import { menuItems } from './menu-items-selector';
import { generateCloudinaryUrl } from '@updater-core/utils/cloudinary';
import * as analytics from './analytics';

export const createInteractor = ({
  interactors: { siteBranding, router, session, journey } = {},
}) => {
  const { getState, setState, subscribe } = createStore({
    isHidden: false,
    entityBrandings: {
      updater: {
        logoUrl:
          'https://res.cloudinary.com/updater-production/image/upload/q_auto:good,c_pad,h_50/updater_logo.jpg',
      },
    },
    poweredByUrl: generateCloudinaryUrl('powered_by_updater', ENVIRONMENT.name),
    showPoweredBy: false,
  });

  let disconnectSiteBranding = () => {};
  if (siteBranding) {
    disconnectSiteBranding = siteBranding.connect(({ entityBrandings }) => {
      setState({
        entityBrandings,
      });
    });
  }

  const disconnectSession = session.connect((state) => {
    const mover = {
      id: session.selectors.uuid(state),
      currentMoveId: session.selectors.currentMoveId(state),
      currentMove: session.selectors.currentMove(state),
      moves: session.selectors.moves(state) || [],
      firstName: session.selectors.userFirstName(state),
      isSignedIn: session.selectors.isAuthenticated(state),
    };
    setState({
      moverDropdown: {
        menuItems: menuItems(mover),
        title: mover.isSignedIn ? `Hi ${mover.firstName}` : 'Sign In',
      },
    });
  });

  const disconnectJourney = journey.connect((state) => {
    const disableMoverDropdown = journey.selectors.disableMoverDropdown(state);
    setState({ disableMoverDropdown });
  });

  return {
    getState,
    connect: (fn) => {
      fn(getState());
      return subscribe(fn);
    },
    analytics,
    subscribe,
    actions: {
      hide() {
        setState({
          isHidden: true,
        });
      },
      show() {
        setState({
          isHidden: false,
        });
      },
      setOnSignIn: (fn) =>
        setState({
          onSignIn: fn,
        }),
      clearOnSignIn: () =>
        setState({
          onSignIn: undefined,
        }),
      showPoweredBy: () => setState({ showPoweredBy: true }),
      hidePoweredBy: () => setState({ showPoweredBy: false }),
      showMoverDropdown: () => setState({ showMoverDropdown: true }),
      hideMoverDropdown: () => setState({ showMoverDropdown: false }),
      enableLogoClick: () => setState({ logoClickEnabled: true }),
      disableLogoClick: () => setState({ logoClickEnabled: false }),
      onLogoClick: () => {
        router?.go('/dashboard');
        analytics?.trackHeaderLogoNavigation();
      },
      routerGo: (route) => {
        router?.go(route);
      },
    },
    selectors: {},
    destroy() {
      disconnectSiteBranding();
      disconnectSession();
      disconnectJourney();
    },
  };
};
